import clsx from "clsx"

import styles from "./ContentEditable.module.css"

export { ContentEditable } from "./ContentEditable"
export { handleEditorFlushSyncError, useEditor } from "./useEditor"

export const contentEditableClass = clsx(
  styles.contentEditable,
  styles["padding-normal"],
  styles["em-normal"],
  styles["p-normal"],
)

export const contentEditablePlaceholderClass = styles.contentEditablePlaceholder
export const contentEditableMultilinePlaceholderClass =
  styles.contentEditableMultilinePlaceholder
